import React, { useState, useEffect } from 'react';

/**
 * MatchProgressIndicator
 *
 * Animated progress indicator shown during AI tutor matchmaking.
 * Features a wobbling/breathing logo animation and cycling status messages.
 */

const LOADING_MESSAGES = [
  "Analyzing student profile",
  "Reviewing learning preferences",
  "Evaluating tutor expertise",
  "Matching personality fit",
  "Calculating confidence scores",
  "Finding best matches"
];

const MatchProgressIndicator = ({ isActive = true }) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [dots, setDots] = useState('.');

  // Cycle through messages every 2.5 seconds
  useEffect(() => {
    if (!isActive) return;
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % LOADING_MESSAGES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [isActive]);

  // Animate dots every 400ms
  useEffect(() => {
    if (!isActive) return;
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '.' : prev + '.');
    }, 400);
    return () => clearInterval(interval);
  }, [isActive]);

  return (
    <div className={`match-progress ${isActive ? 'match-progress--active' : ''}`}>
      <div className="match-progress__logo-container">
        <div className="match-progress__pulse-ring" />
        <div className="match-progress__pulse-ring match-progress__pulse-ring--delayed" />
        <img
          src="/lrbrain-logo.png"
          alt=""
          className="match-progress__logo match-progress__logo--animated"
        />
      </div>

      <div className="match-progress__content">
        <p className="match-progress__message">
          {LOADING_MESSAGES[messageIndex]}
          <span className="match-progress__dots">{dots}</span>
        </p>
        <div className="match-progress__shimmer">
          <div className="match-progress__shimmer-bar" />
        </div>
      </div>

      <p className="match-progress__subtext">
        Our AI is finding the best tutor matches based on learning style,
        subject expertise, and personality fit.
      </p>
    </div>
  );
};

export default MatchProgressIndicator;
